import { RegionShared } from "@1games-ru/region-shared";
import { useLayoutEffect } from "react";
import rpc from "@1games-ru/rage-rpc";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { setEstateEnterInfo, setShowSaleConfirm } from "@/domains/estate/slice";
import useLoadEstateInfo from "@/domains/estate/hooks/useLoadEstateInfo";

export default () => {
  const dispatch = useAppDispatch();
  const { getEstateGuestInfo } = useLoadEstateInfo();

  useLayoutEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Estate.EstateEnterShow,
      async (state: typeof RegionShared.Cef.Requests.EstateEnterShowRequest): Promise<void> => {
        const estateInfo = await getEstateGuestInfo(state.estateId);
        dispatch(setEstateEnterInfo(estateInfo));
      },
    );

    rpc.register(RegionShared.Cef.Events.Estate.EstateEnterHide, async (): Promise<void> => {
      setTimeout(() => {
        dispatch(setEstateEnterInfo(null));
        dispatch(setShowSaleConfirm(false));
      }, 100);
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Estate.EstateEnterShow);
      rpc.unregister(RegionShared.Cef.Events.Estate.EstateEnterHide);
    };
  }, [dispatch, getEstateGuestInfo]);
};
